import {Chip, Stack} from '@mui/material';
import {QueryParamsEnum} from 'presentation/constants';
import {useQueryParams} from 'presentation/pages/private/hooks';
import {translations} from 'presentation/translations-new';
import React from 'react';
import {AutoSolEnum} from 'main/analytics/gaTagsEnum';
import {AuthorizationStatusEnum} from '../../constants';
import {AuthorizationsFilterProps, FilterProps, FilterVariant} from './types';

const {status: statusLabel} = translations['pt-br'].privateFlow.requestAuthorizations;

export function AuthorizationsFilter({variant = 'authorizations'}: AuthorizationsFilterProps) {
	const {SEARCH_PARAMS, setSearchParams} = useQueryParams();
	const {authorizationStatus} = SEARCH_PARAMS;

	function handleSelectFilter(type: AuthorizationStatusEnum) {
		setSearchParams(prev => {
			if (type === AuthorizationStatusEnum.ALL) {
				prev.delete(QueryParamsEnum.AUTHORIZATION_STATUS);
				return prev;
			}
			prev.set(QueryParamsEnum.AUTHORIZATION_STATUS, type);
			return prev;
		});
	}

	const isActive = (category: AuthorizationStatusEnum) =>
		category === AuthorizationStatusEnum.ALL
			? !authorizationStatus || authorizationStatus === AuthorizationStatusEnum.ALL
			: authorizationStatus === category;

	const filtersByVariant: Record<FilterVariant, FilterProps[]> = {
		authorizations: [
			{
				category: AuthorizationStatusEnum.ALL,
				label: statusLabel.all,
				dataTagId: AutoSolEnum.AS_CLICK_FILTRO_TODOS,
			},
			{
				category: AuthorizationStatusEnum.SUCCESS,
				label: statusLabel.success,
				dataTagId: AutoSolEnum.AS_CLICK_FILTRO_LIBERADO,
			},
			{
				category: AuthorizationStatusEnum.PENDING,
				label: statusLabel.pending,
				dataTagId: AutoSolEnum.AS_CLICK_FILTRO_PENDENTE,
			},
			{
				category: AuthorizationStatusEnum.UNDER_ANALYSIS,
				label: statusLabel.underAnalysis,
				dataTagId: AutoSolEnum.AS_CLICK_FILTRO_EM_ANALISE,
			},
			{
				category: AuthorizationStatusEnum.REJECTED,
				label: statusLabel.rejected,
				dataTagId: AutoSolEnum.AS_CLICK_FILTRO_INDEFERIDO,
			},
		],
		requests: [
			{
				category: AuthorizationStatusEnum.ALL,
				label: statusLabel.all,
				dataTagId: AutoSolEnum.AS_CLICK_FILTRO_TODOS_ANDAMENTO,
			},
			{
				category: AuthorizationStatusEnum.REGISTERED,
				label: statusLabel.registered,
				dataTagId: AutoSolEnum.AS_CLICK_FILTRO_REGISTRADO,
			},
			{
				category: AuthorizationStatusEnum.UNDER_ANALYSIS,
				label: statusLabel.underAnalysis,
				dataTagId: AutoSolEnum.AS_CLICK_FILTRO_EM_ANALISE,
			},
			{
				category: AuthorizationStatusEnum.PENDING,
				label: statusLabel.pending,
				dataTagId: AutoSolEnum.AS_CLICK_FILTRO_PENDENTE_ANDAMENTO,
			},
			{
				category: AuthorizationStatusEnum.FINISHED,
				label: statusLabel.finished,
				dataTagId: AutoSolEnum.AS_CLICK_FILTRO_CONCLUIDO,
			},
		],
	};

	const filters = filtersByVariant[variant];

	return (
		<Stack direction="row" gap={1} flexWrap="wrap" sx={{overflowX: 'auto'}}>
			{filters.map(filter => {
				const active = isActive(filter.category);

				return (
					<Chip
						key={filter.category}
						label={filter.label}
						clickable
						color="primary"
						variant={active ? 'filled' : 'outlined'}
						onClick={() => handleSelectFilter(filter.category)}
						data-tag-id={filter.dataTagId}
						sx={{
							cursor: 'pointer',
							color: active ? 'primary.contrastText' : 'primary.main',
							borderColor: 'primary.main',
							backgroundColor: active ? 'primary.main' : 'transparent',
						}}
					/>
				);
			})}
		</Stack>
	);
}
